export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
    data-testid="logo-mark"
  >
    <rect x="3" y="3" width="58" height="58" stroke="currentColor" strokeWidth="2.5" />
    <path
      d="M43 21c-2.2-3.4-6.6-5.2-11.2-5.2-6.8 0-11.8 3.9-11.8 9.7 0 12.6 23.6 8.2 23.6 20 0 5.9-5.6 9.7-12.6 9.7-5.8 0-10.6-2.7-12.6-7.6"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="square"
    />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`} data-testid="wordmark">
    <LogoMark />
    <span className="font-serif text-2xl tracking-tight">Symmori</span>
  </span>
);
